export function parseUtmFromTgStartParam(str) {
  const parts = str.split("_");
  const result = {};

  for (const part of parts) {
    // разделяем по первому дефису
    const [key, value] = part.split("-", 2);
    if (key === "refId") {
      continue;
    }
    if (key === "subid") {
      result.keitaro_id = value.replaceAll("A", ".");
    } else if (key && value) {
      // приводим ключ к стандартному формату utm_source / utm_medium / utm_campaign
      result[key.replace(/([A-Z])/g, "_$1").toLowerCase()] = value;
    }
  }
  return result;
}
